import { VUE_APP_SHOW_LOGIN_TABLE }  from 'constants/fileConstants'
export default VUE_APP_SHOW_LOGIN_TABLE ? [
  {
    login: 'admin@admin.cz',
    password: 'test',
    role: 'admin'
  },
  {
    login: 'user@user.cz',
    password: 'test',
    role: 'user'
  }
] : []
